<div class="sl-accordion-section">
  <input class="sl-accordion-checkbox" type="checkbox" [id]="'sl-accordion-checkbox-' + sectionId">

  <label class="sl-accordion-section-label" [for]="'sl-accordion-checkbox-' + sectionId">
    <h6>{{title}}</h6>
  </label>
  <div class="sl-accordion-content">
    <ng-content></ng-content>
  </div>
</div>
